import {createSlice} from '@reduxjs/toolkit'

const initialState = {
    recommendations: null,
    newDisney: null,
    originals: null,
    trending: null,
}

const movieSlice = createSlice({
    name: 'movie',
    initialState,
    reducers: {
        setMovies: (state, action) => {
            state.recommendations = action.payload.recommendations;
            state.newDisney = action.payload.newDisney;
            state.originals = action.payload.originals;
            state.trending = action.payload.trending;
        }
    }
})

export const {setMovies} = movieSlice.actions;

export const selectedRecommendations = state => state.movie.recommendations;
export const selectedNew = state => state.movie.newDisney;
export const selectedOriginals = state => state.movie.originals;
export const selectedTrending = state => state.movie.trending;

export default movieSlice.reducer;